module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/default-c1b2178526f98c9ae6aa748b39b999f8.jpg";